import { g as getRoomType } from './get-room-type.js';
import './index2.js';

/**
* *Fairmont/Accor*
*
* @exports bs_381
* @category engines
*/
function factory({ window, document, thn }) {

  const engine = {};
  let nights;

  /**
     * @memberOf module:bs_381
     * @see {@link is_user_logged}
     *
     * @param {object} ctx - The context object.
     */
  engine.isUserLogged = function isUserLogged(ctx) {

    const isLogged = !!document.querySelector('#dvLoggedIn');

    return isLogged;
  };

  /**
     * @memberOf module:bs_381
     * @this thn.widgets.price
     * @see {@link Price#set_data}
     *
     * @param {object} ctx - The context object.
     */
  function roomDetailsParseData(roomsContainer, occupancy) {

    if (!roomsContainer) {
      return undefined;
    }
    const roomDetailsArray = [...roomsContainer].map((roomElement) => {
      const roomName = roomElement.querySelector('h3 .second-level-heading-text')?.textContent?.trim();
      const roomType = getRoomType(roomName);
      const roomRates = [...roomElement.querySelectorAll('.classPositionRelative .internal-accordian')]
        .map((rate) => {
          const rateName = rate.querySelector('.internal-accordian-header h4 button')?.textContent?.trim();
          const priceEl = rate.querySelector('.rate');
          const price = thn.parseNumber(priceEl?.textContent?.trim());
          const detailsContainer = rate.querySelector('.rate-plan-title');
          const detailsText = detailsContainer?.textContent?.toLowerCase();
          const isBreakfast = detailsText?.includes('breakfast');
          const isRefundable = detailsText?.includes('flexible');
          const rates = {
            id: '',
            name: rateName,
            totalNight: price,
            breakfast: isBreakfast,
            refundable: isRefundable,
          };
          return rates;
        });

      return {
        id: '',
        name: roomName,
        adults: occupancy.adults,
        children: occupancy.children,
        type: roomType,
        prices: roomRates,
      };
    }).filter(Boolean);

    return roomDetailsArray;
  }

  /**
   * @memberOf module:bs_381
   * @this thn.widgets.price
   * @see {@link Price#observe_dom}
   *
   * @param {object} ctx - The context object.
   */
  engine.priceObserveDom = function priceObserveDom(ctx) {
    const containerRooms = document.querySelector('[id*=MainReservationContent_updRooms]');

    if (containerRooms) {
      let refreshPrice = thn.debounce(() => ctx.widget.refresh(), 400);

      thn.observeDom(containerRooms, refreshPrice, {
        childList: true,
        subtree: false,
        attributes: true,
      });

      thn.pageUnload(() => {
        refreshPrice.cancel();
        thn.stopObserveDom(containerRooms, refreshPrice);
        refreshPrice = null;
      });
    }
  };

  /**
     * @memberOf module:bs_381
     * @this thn.widgets.price
     * @see {@link Price#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.priceParseData = function priceParseData(ctx) {

    const widgetData = {};
    const noRoomsMsg = thn.dataLayerHelper.get('errorMessage')?.includes('no rooms');
    const priceWithoutTaxes = document.querySelector('.feesToggle_Container button')?.className?.includes('showFlex');

    // Dates
    const dateBeginEl = thn.dataLayerHelper.get('page_data')?.arrival_date;
    const dateEndEl = thn.dataLayerHelper.get('page_data')?.departure_date;
    const dateBegin = dateBeginEl?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$1/$2');
    const dateEnd = dateEndEl?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$1/$2');

    if (dateBegin && dateEnd) {
      widgetData.dateBegin = dateBegin;
      widgetData.dateEnd = dateEnd;
      nights = thn.daysBetween(dateBegin, dateEnd);
    }
    // Guests, Adults & Children

    // Each room shows its own available occupancy
    const roomsContainer = document.querySelectorAll('.content.padd-conten .form-section');
    const roomsInfo = [...roomsContainer].map((roomEl) => {
      const adultsDl = thn.dataLayerHelper.get('page_data')?.adults_nb;
      const childrenDl = thn.dataLayerHelper.get('page_data')?.children_nb;
      const adults = thn.parseNumber(adultsDl);
      const children = thn.parseNumber(childrenDl);
      const childrenAges = [];
      for (let i = 0; i < children; i += 1) {
        childrenAges.push(2);
      }
      const occupancy = adultsDl || childrenDl;
      const price = thn.parseNumber(roomEl.querySelector('.rate')?.textContent);
      if (occupancy && price) {
        return {
          adults: adults,
          children: children,
          price: price,
          childrenAges,
        };
      }
      return false;
    }).filter(Boolean);

    const roomsOrderedByPrice = roomsInfo.sort((a, b) => a.price - b.price);
    const { adults, children } = roomsOrderedByPrice?.[0] ?? { adults: 2, children: 0 };
    const occupancy = { adults: adults, children: children };

    const currency = document.querySelector('[name*=ddlCurrencySelection] [selected=selected]')?.value || thn.parseCurrency(document.querySelector('.currency-rate')?.textContent);

    const promoApplied = thn.dataLayerHelper.get('page_data')?.offer_code;
    if (promoApplied) {
      widgetData.priceSpecial = 1;
    }

    if (currency && nights && roomsInfo.length) {
      widgetData.roomsDispo = [roomsOrderedByPrice[0]];
      widgetData.price = roomsOrderedByPrice[0].price;
      widgetData.priceType = priceWithoutTaxes ? 'base' : 'full';
      widgetData.currency = currency;
      widgetData.roomDetails = roomDetailsParseData(roomsContainer, occupancy);
      widgetData.set = true;
    } else if (noRoomsMsg) {
      widgetData.noRooms = true;
    }

    return widgetData;
  };

  /**
       * @memberOf module:bs_381
       * @this thn.widgets.booking
       * @see {@link Booking#set_data}
       *
       * @param {object} ctx - The context object.
       */
  engine.bookingParseData = function bookingParseData(ctx) {

    const widgetData = {};

    const bookingId = thn.dataLayerHelper.get('ecommerce')?.transaction_id
      || document.querySelector('.confirmation-number-container p')?.textContent;

    if (!bookingId) {
      widgetData.set = false;
      return widgetData;
    }

    // booking ID
    widgetData.bookingId = bookingId;

    // Dates
    const dateBeginEl = thn.dataLayerHelper.get('page_data')?.arrival_date;
    const dateEndEl = thn.dataLayerHelper.get('page_data')?.departure_date;
    const dateBegin = dateBeginEl?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$1/$2');
    const dateEnd = dateEndEl?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$1/$2');

    widgetData.dateBegin = dateBegin;
    widgetData.dateEnd = dateEnd;

    // Guests
    const adultsDl = thn.dataLayerHelper.get('page_data')?.adults_nb;
    const childrenDl = thn.dataLayerHelper.get('page_data')?.children_nb;
    const adults = thn.parseNumber(adultsDl);
    const children = thn.parseNumber(childrenDl);

    widgetData.adults = adults || 2;
    widgetData.children = children || 0;
    widgetData.guests = widgetData.adults + widgetData.children;
    widgetData.rooms = thn.dataLayerHelper.get('page_data')?.rooms_nb || 1;

    // Price & Currency
    const totalPriceDom = document.querySelector('#room-info\\ richtext-link-title p')?.textContent?.trim();
    const price = thn.parseNumber(totalPriceDom) || thn.parseNumber(thn.dataLayerHelper.get('ecommerce')?.value);
    const currency = thn.parseCurrency(totalPriceDom) || thn.dataLayerHelper.get('ecommerce')?.currency || thn.dataLayerHelper.get('currency');

    widgetData.price = price;
    widgetData.currency = currency;

    return widgetData;

  };

  return engine;
}

export { factory };
